<svelte:head>
    <script  src="../dist/echarts.min.js"
			  crossorigin="anonymous"
			  on:load={echartsLoaded}
			  defer>
  </script>  

</svelte:head>

<script>

//
//  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import
//     import defaultExport from "module-name";
//     import * as name from "module-name";
//     import { export1 } from "module-name";
//     import { export1 , export2 as alias2 , [...] } from "module-name";
//     import "module-name";
//     var promise = import("module-name");
//

import { onMount, onDestroy } from 'svelte';

import { loggedIn                                                   } from '../_services/accountsession.js';
import { cubejsclient_service  , cubejsclient_service_context_key   } from '../_services/cubejsClient.js';

//import MySvelteChart			from './Page_0001_Chart.svelte';   


// ----------------------------------------------------
// --   DECLARATIONS
// ----------------------------------------------------

let display_chart = false;


let xAxis_headers = [];

   var is_dataLoaded = false;
	onMount(async () => {
		if ($loggedIn) {
			is_dataLoaded = true;
		}
	});


  var is_dependenciesLoaded = false;
  function dependenciesLoaded() {
  		if (   true 
  		       && is_echartsLoaded 
  		       && is_dataLoaded
  		   )
  	  {
			is_dependenciesLoaded = true;
  		}
  }

  var is_echartsLoaded = false;
  function echartsLoaded() {
		// The external javascript library is ready.
		is_echartsLoaded = true;
		dependenciesLoaded();
  }

  
// ----------------------------------------------------
// --   RUNTIME 
// ----------------------------------------------------


//$: run = is_dependenciesLoaded && handleClickGetResult()  // <<-- should be hanlded in the onMount() ??

$: display_chart = is_dependenciesLoaded;

</script>

<style>

	.applet {
		width: inherit;
		height:550px;
	}

	.chart_wrapper {
		width: inherit;
		margin: 0 auto;
		padding: 0px;
		
		display: flex; /* or inline-flex */
		/* flex-wrap: wrap; */
		flex-flow: row wrap;
		justify-content: flex-start; /* flex-start | space-around | space-evenly*/
	}

	.chart {
		width: inherit;
		height:450px;
	}
 
</style>


<div class="applet">
	<div>
		<p>My Finances :: Financial Statements</p>
		<p>App Chart_Xa8envOyb2BZlLqo</p>
	</div>

	{#if $loggedIn}


		{#if display_chart}
		<div class="chartWrapper">
			<div id="chart" class="chart"></div>
			<script type="text/javascript" >
		
			      var query_environment = 'dev';
					var query_id = 'Xa8envOyb2BZlLqo';

					// Call an authentication microservice to handle the authentication.
					var response =  fetch("https://analytics.artificiality.be/"+query_environment+"/cubejs/"+query_id+"/result?instrument=EUR%2FCHF&autoLimit=10000",
							{
							    method: 'GET',
							    credentials: 'include',    // omit | include | same-origin
							    headers: {
							        'api_id': 'CUBEJS_API_KEY',
							        'client_id': 'CUBEJS_CLIENT_ID',
							        'client_secret': 'CUBEJS_CLIENT_SECRET',
							        'client_session': CUBEJS_CLIENT_SESSION,
							        'Content-Type': 'application/vnd.artificiality.cubejs.query-v1+json',
							        'Accept':       'application/vnd.artificiality.cubejs.queryresult-v1+json',
				   			    },
							    body: JSON.stringify(  ),
							})
					.then((response) => response.json() )
					.then((response) => { 
								// -=-=-=-=-=-=-=-=-=-=-=-  begin - process logic =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=

							if (response.data) {
					
					  			if ( response.data.length > 0 ) {
					  			
				                 var xAxis_tick_labels = [];
				                 var series_labels = [];
				                 response.data.forEach(function (arrayItem) {
										    xAxis_tick_labels[ arrayItem["MyfinancesOandaFxtransactions.oandaFXStatementDt"] ] = true;
										    series_labels[     arrayItem["MyfinancesOandaFxtransactions.tradeId"]            ] = true;
										});
		
		//console.log( Object.keys( xAxis_tick_labels ) );
		//console.log( Object.keys( series_labels ) );
		//console.log( xAxis_tick_labels.keys() );
		//for (x of xAxis_tick_labels.keys()) {
		//  document.getElementById("demo").innerHTML += x + "<br>";
		//} 
		
										xAxis_tick_labels.sort();
										xAxis_tick_labels.reverse();
										var series_data = Object.keys( series_labels )
									            				  .map(series_label => {
																		    return { label: series_label,
																		    			 data: Object.keys( xAxis_tick_labels )
															                      				  .sort()
															                                   .map(xAxis_tick_label => {
															                                          var series_datapoint = null;
															                                  			response.data.forEach(function (datapoint) {
		
														            													if (   datapoint["MyfinancesOandaFxtransactions.oandaFXStatementDt"] === xAxis_tick_label
																				            										&& datapoint["MyfinancesOandaFxtransactions.tradeId"] === series_label
														            													  ) {
																				            										 series_datapoint = datapoint["MyfinancesOandaFxtransactions.measure_Max_Price"] ;
																				            								} else {
																				            								}
		
															                                  				});
																														return series_datapoint;
														                                  			})
																		    			 };
																			});
		console.log(series_data);
					
					              // based on prepared DOM, initialize echarts instance
							        var myChart = echarts.init(document.getElementById('chart'));
							        
							        // specify chart configuration item and data
							        var option = {
							            title: {
							                text: 'FXTransaction Evolution - EUR/CHF'
							            },
							            tooltip: {},
							            legend: {
							                data:['FXTicker Price']
							            },
										    dataZoom: [
										        {
										            type: 'slider',
										            show: true,
										            xAxisIndex: [0],
										            start: 0,
										            end: 35
										        },
										        {
										            type: 'slider',
										            show: true,
										            yAxisIndex: [0],
										            left: '93%',
										            start: 99,
										            end: 100
										        },
										        {
										            type: 'inside',
										            xAxisIndex: [0],
										            start: 0,
										            end: 35
										        },
										        {
										            type: 'inside',
										            yAxisIndex: [0],
										            start: 99,
										            end: 100
										        }
										    ],
							            xAxis: {
							              data: Object.keys( xAxis_tick_labels )
							              				  .sort()
							            },
							            yAxis: {},
							            series: series_data.map(function( series_obj ) {
							            									return {
																	                name: 'tradeId::'+ series_obj.label,
																	                type: 'line',
															                      stack: ''+ series_obj.label,
															                      data:  series_obj.data
																	            };
							            								})
							        };
		
						           // use configuration item and data specified to show chart
							        myChart.setOption(option);	
		
									}
						 
							} else {
								// invoke callback
								console.log(/*exception obj*/ {type : 'exception', 
																			msg: 'something went wrong' } );
							}     


								// -=-=-=-=-=-=-=-=-=-=-=-  end - process logic =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
					}) 
					.catch((err) => {
									console.log(/*exception obj*/ {type : 'exception', 
																				msg: '[catch] something went wrong: '+ err.message } );
					})
					;
		
			</script>
		</div>
	
		{:else}
		<div>
				<p>Loading data and scripts and what not...</p>
		</div>
	
		{/if}


	{:else}
	<div>
		<p>Please log in...</p>
	</div>
	{/if}
	
</div>
